export default "__VITE_ASSET__da1eb84a__"